import { ISupplementCategories } from 'app/shared/model/supplement-categories.model';

export interface ISupplements {
  id?: number;
  name?: string;
  quantity?: string;
  imageContentType?: string;
  image?: string;
  flavour?: string;
  suitedFor?: string;
  description?: string;
  image2ContentType?: string;
  image2?: string;
  image3ContentType?: string;
  image3?: string;
  isAvailable?: boolean;
  price?: number;
  category?: ISupplementCategories;
}

export const defaultValue: Readonly<ISupplements> = {
  isAvailable: false,
};
